import { FC } from "react";
import useEvent from "react-use-event-hook";
import styled from "styled-components";

import { useCrudNavigate } from "@ryde/redux";
import {
  DATA_E2E_KEY,
  DialogType,
  DrawerType,
  IStyledAttributes,
  RydeAppUnit,
  useDialogs,
  useDrawers,
} from "@ryde/shared";
import { blueMui } from "@ryde/theme";

export const LinkToEntityRelationStyled = styled.span.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "link-to-entity-relation-container",
})`
  color: ${blueMui.A400};
  cursor: pointer;
`;

interface IRelationRowsIds {
  relation: string;
  ids: string[];
}

const TOTAL_IDS_TO_SHOW = 3;

export const RelationRowsIds: FC<IRelationRowsIds> = ({ ids, relation }) => {
  const { closeDialog } = useDialogs();
  const { closeDrawer } = useDrawers();
  const { navigateToEdit } = useCrudNavigate(relation as RydeAppUnit);

  const onEditLinkClick = useEvent((id: string) => {
    closeDialog(DialogType.BulkArchiveRelationErrorDisplayDialog);
    closeDrawer(DrawerType.ProcessDrawer);
    navigateToEdit(+id);
  });

  return (
    <td>
      {ids?.slice(0, TOTAL_IDS_TO_SHOW).map((id: string, index) => {
        return (
          <LinkToEntityRelationStyled
            key={id}
            onClick={() => onEditLinkClick(id)}
          >
            {id}
            {index < ids.length - 1 && ", "}
          </LinkToEntityRelationStyled>
        );
      })}

      {ids?.length > TOTAL_IDS_TO_SHOW && (
        <span>{`+${ids.length - TOTAL_IDS_TO_SHOW}`}</span>
      )}
    </td>
  );
};
